import { getTransactionType } from 'hooks/useTransactionsList/useTransactionsList.utils'
import { TransactionInList } from 'types/transactions'

const NO_RECORD_ERROR = 'no-record'

export const getTypeAndMaskedPan = (transaction: TransactionInList) => {
  if (transaction.maskedPan) {
    const re = /\d{4}/
    const match = re.exec(transaction.maskedPan)

    if (transaction.maskedPan === NO_RECORD_ERROR || !match) {
      return getTransactionType(transaction.type)
    }

    return `${getTransactionType(
      transaction.type
    )} ••• ${transaction.maskedPan.slice(-4)}`
  }

  return getTransactionType(transaction.type)
}
